// **************
// bannercarousel.jsx
// autor: Walcledson de Paula/IA
// data: 13/6/24 / 16:41h
// *************

import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './bannercarousel.css';

function BannerCarousel ({ banners })  {
    const settings = {
        dots: true,
        // infinite: true,
        infinite: banners.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        <Slider {...settings}>
            {banners.map((banner, index) => (
                <div key={index}>
                    <img src={`data:image/jpeg;base64,${banner.FOTO}`} alt={banner.BANNER} className="img-fluid" />
                    <h5 className="text-center">{banner.BANNER}</h5>
                </div>                
            ))}
        </Slider>
    );
};

export default BannerCarousel;
